<div class="tab-bar" #scrollContainer>
  <div
    *ngFor="let item of items"
    class="tab-item"
    [class.active]="selectedId === item.id"
    (click)="onTabClick(item)">
    <span class="tab-label">{{ item.name }}</span>
    <div class="tab-indicator"></div>
  </div>
</div>
